module.exports = __webpack_public_path__ + "img/1408080458.601b960d.jpg";